import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import todoSagas from './todo/saga';
import chatSagas from './chat/saga';
import surveyListSagas from './surveyList/saga';
import surveyDetailSagas from './surveyDetail/saga';
// import userManagementSagas from './user/saga';
// import companyDetailSagas from './company/saga';
import staffManagementSagas from './settingManagement/staffManagement/saga';
import userManagementSagas from './settingManagement/userManagement/saga';
import companyDetailSagas from './settingManagement/companyDetail/saga';
import treatmentManagementSagas from './settingManagement/treatmentManagement/saga';
import bedManagementSagas from './settingManagement/bedManagement/saga';
import promotionManagementSagas from './settingManagement/promotionManagement/saga';
import membershipManagementSagas from './settingManagement/membershipManagement/saga';
import packageManagementSagas from './settingManagement/packageManagement/saga';
import customerManagementSagas from './settingManagement/customerManagement/saga';
import serviceFeeManagementSagas from './settingManagement/serviceFeeManagement/saga';
import inventoryManagementSagas from './settingManagement/inventoryManagement/saga';
import couponManagementSagas from './settingManagement/couponManagement/saga';

import queueManagementSagas from './queueManagement/saga';
import housekeepingManagementSagas from './housekeepingManagement/saga';
import bookingManagementSagas from './bookingManagement/saga';
import pettyCashManagementSagas from './pettyCashManagement/saga';
// เพิ่มบรรทัดนี้: Import POS Saga
import posManagementSagas from './posManagement/saga';

// import promotionSagas from './promotion/saga'; 
// import bookingSagas from './booking/saga';
// import AddressOptionSagas from './address/saga'; 

export default function* rootSaga() {
  yield all([
    authSagas(),
    todoSagas(),
    chatSagas(),
    surveyListSagas(),
    surveyDetailSagas(),

    userManagementSagas(),
    companyDetailSagas(),
    staffManagementSagas(),
    treatmentManagementSagas(),
    bedManagementSagas(),
    promotionManagementSagas(),
    membershipManagementSagas(),
    packageManagementSagas(),
    customerManagementSagas(),
    serviceFeeManagementSagas(),
    inventoryManagementSagas(),
    couponManagementSagas(),

    queueManagementSagas(),
    housekeepingManagementSagas(),
    bookingManagementSagas(),
    pettyCashManagementSagas(),
    // เพิ่มบรรทัดนี้: เรียกใช้ POS Saga
    posManagementSagas(),

    // promotionSagas(),
    // bookingSagas(),
    // AddressOptionSagas(),
  ]);
}
